import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, NUMBER, INTEGER, STRING, UUID, COLLECTION, ITEM, ARRAY } from '@/plugins/sdk/fields'
import Item from '@/plugins/sdk/resources/Consignment/Item'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Team from './Team'
import Account from './Account'
import Service from './Service'
import Tracking from './Tracking/Tracking'
import Pickup from './Pickup'
import Edi from './Edi'
import ErrorReport from './Tracking/ErrorReport'
import Subscription from './Tracking/Subscription'
import ConPricing from './Billing/ConPricing'
import InvPricing from './Billing/InvPricing'
import Watchlist from './Profile/Watchlist'
import Feature from './Consignment/Feature'
import CustomerIOLog from './CustomerIOLog'
import MessageBirdLog from './MessageBirdLog'

export default class extends Resource {
  static name = 'consignment'
  static label = 'con_full'

  static get fields () {
    return {
      con_id: new INTEGER(),
      id: new UUID(),
      con_full: new STRING(),
      con_created_date: new DATETIME(),
      con_despatch_date: new DATETIME(),
      con_manifest_date: new DATETIME(),
      con_delivery_date: new DATETIME(),
      con_estimate_date: new DATETIME(),
      con_ref: new STRING(),
      con_internal_ref: new STRING(),
      con_sum_items: new INTEGER(),
      con_sum_weight: new NUMBER(),
      con_sum_cube: new NUMBER(),
      con_sender_name: new STRING(),
      con_sender_address_1: new STRING(),
      con_sender_address_2: new STRING(),
      con_sender_town: new STRING(),
      con_sender_state: new STRING(),
      con_sender_postcode: new STRING(),
      con_sender_contact: new STRING(),
      con_sender_phone: new STRING(),
      con_sender_email: new STRING(),
      con_sender_residential: new BOOLEAN(),
      con_receiver_name: new STRING(),
      con_receiver_address_1: new STRING(),
      con_receiver_address_2: new STRING(),
      con_receiver_town: new STRING(),
      con_receiver_state: new STRING(),
      con_receiver_postcode: new STRING(),
      con_receiver_contact: new STRING(),
      con_receiver_phone: new STRING(),
      con_receiver_email: new STRING(),
      con_receiver_residential: new BOOLEAN(),
      con_special_instructions: new STRING(),
      con_pal_chep: new INTEGER(),
      con_pal_loscam: new INTEGER(),
      con_pal_other: new INTEGER(),
      con_est_price: new NUMBER(),
      con_costcent: new STRING(),
      con_validated: new BOOLEAN(),
      con_is_dg: new BOOLEAN(),
      authority_to_leave: new BOOLEAN(),
      manifest_name: new STRING(),
      pricing_data: new STRING(),
      edi_id: new NUMBER(),
      edi: new ITEM(Edi),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      pickup: new ITEM(Pickup),
      items: new COLLECTION(Item),
      carrier: new ITEM(Carrier),
      service: new ITEM(Service),
      account: new ITEM(Account),
      con_type: new STRING(),
      team: new ITEM(Team),
      trackings: new COLLECTION(Tracking),
      con_ext_data: new STRING(),
      zone_from: new STRING(),
      zone_to: new STRING(),
      enquiries: new ARRAY(),
      tracking_errors: new COLLECTION(ErrorReport),
      tracking_subscriptions: new COLLECTION(Subscription),
      con_rtp_type: new NUMBER(),
      con_rtp_account: new STRING(),
      account_own_carrier: new BOOLEAN(),
      quoted_pricing: new ARRAY(),
      con_pricing: new ITEM(ConPricing),
      inv_pricing: new ITEM(InvPricing),
      watchlists: new COLLECTION(Watchlist),
      features: new ITEM(Feature),
      application: new STRING(),
      is_on_watchlist: new BOOLEAN(),
      emails: new COLLECTION(CustomerIOLog),
      sms: new COLLECTION(MessageBirdLog)
    }
  }

  static get sortables () {
    return [
      { field: 'con_id', label: 'ID' },
      { field: 'con_created_date', label: 'Created Date' },
      { field: 'con_despatch_date', label: 'Despatch Date' },
      { field: 'con_delivery_date', label: 'Delivery Date' },
      { field: 'con_estimate_date', label: 'Estimate Date' },
      { field: 'con_ref', label: 'Reference' },
      { field: 'con_sender_name', label: 'Sender Name' },
      { field: 'con_sender_postcode', label: 'Sender Postcode' },
      { field: 'con_receiver_name', label: 'Receiver Name' },
      { field: 'con_receiver_postcode', label: 'Receiver Postcode' },
      { field: 'con_sum_weight', label: 'Weight' },
      { field: 'con_sum_cube', label: 'Cube' },
      { field: 'con_est_price', label: 'Estimated Price' },
      { field: 'carrier.name', label: 'Carrier' },
      { field: 'service.name', label: 'Service' }
    ]
  }
}
